import React from 'react';

const StatusBadge = ({ statusCode, status }) => {
	const getBgClassByStatusCode = (code) => {
		switch (code) {
			case 'completed':
				return 'bg-green-400 text-green-900';
			case 'ahead':
				return 'bg-blue-400 text-blue-900';
			case 'behind':
				return 'bg-red-400 text-red-900';
			case 'on-track':
				return 'bg-yellow-400 text-yellow-900';
			case 'failed':
				return 'bg-red-800 text-red-100';
			default:
				return 'bg-gray-400 text-gray-900';
		}
	};

	const getIcon = () => {
		switch (statusCode) {
			case 'completed':
				return '✅';
			case 'ahead':
				return '🚀';
			case 'behind':
				return '⚠️';
			case 'on-track':
				return '🎯';
			case 'failed':
				return '❌';
			default:
				return '⏳';
		}
	};

	return (
		<span
			className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getBgClassByStatusCode(
				statusCode
			)}`}
		>
			<span className='mr-1'>{getIcon()}</span>
			{status}
		</span>
	);
};

export default StatusBadge;
